<template>
  <div class="content-post-show">
   <div v-if="info">
     <div class="video">
      <iframe
      class="video_iframe"
      style="z-index:1;"
      :src="'https://v.qq.com/iframe/player.html?vid=' + info.videoid + '&amp;width=auto&amp;height=auto&amp;auto=0'"
      allowfullscreen="true"
      frameborder="0"
      height="250"
      width="100%"
      >
    </iframe>
  </div>
</div>
<div class="show" v-if="info">
  <h3><van-tag class="mr-10" v-if="info.label!=null" color="#F3F9FF" text-color="#728FC4">{{info.label.name}}</van-tag>
    <span class="posttitle">{{ info.title }}</span>
  </h3>
  <div class="media" v-if="info.media">
    <span class="mr-10">{{ info.media.name }}</span>
    <span>{{ info.time_format }}</span>
  </div>
  <div v-html="content" class="content"></div>
  <!-- <div class="mt-40">
    <span class="c-gray f-12">阅读{{info.click}}</span>
    <span class="f-r c-gray f-12" @click="toTip">举报</span>
  </div> -->
  <div class="parise" hidden="true">
    <router-link to="">
      <img :src="img.show_parise" />
      值得看 {{ info.praise }}
    </router-link>
    <router-link to="">
      <img :src="img.show_no_parise" />
      一般般
    </router-link>
  </div>
</div>
<div class="recommend" v-if="recommends.length > 0">
  <h3><span class="borderleft"></span>其他作品</h3>
  <van-row gutter="15" v-for="re in recommends" :key="'recommend_' + re.id">
    <van-col span="10">
      <router-link :to="{name: 'LexusPostShow', params: {id: re.id}}">
        <img v-lazy="re.pic_url" :alt="re.title" />
      </router-link>
    </van-col>
    <van-col span="14">
      <router-link :to="{name: 'LexusPostShow', params: {id: re.id}}">
        <h2><van-tag class="mr-10" v-if="re.label" color="#F3F9FF" text-color="#728FC4">{{ re.label.name}}</van-tag>
          <span class="posttitle">{{ re.title }}</span>
        </h2>
      </router-link>
    </van-col>
  </van-row>
</div>
<div class="recommend">
  <h3 v-if="tripartite_info.length>0">当前文章第三方平台数据<span class="f-12 c-gray" style="font-weight: 400">（每24小时更新一次）</span></h3>
  <van-grid :border="false" :column-num="3">
    <van-grid-item v-for="item in tripartite_info" :key="'tripartite_info_' + item.title">
      <van-row>
        <van-col span="8">
          <img class="picthere" :src="item.logo">
        </van-col>
        <van-col span="15" offset="1">
          <div class="f-12">{{item.title}}</div>
          <div class="f-12 mt-5" v-if="item.read_num!=0">{{item.read_num}}人阅读</div>
          <div class="f-12 mt-5" v-if="item.read_num==0&&item.comment_num!=0">{{item.comment_num}}人评论</div>
        </van-col>
      </van-row>
    </van-grid-item>
  </van-grid>
  <van-row type="flex" justify="space-between" class="f-12 c-gray">
    <van-col span="22">
      {{info.read_text}}
    </van-col>
    <van-col span="2">
      <span @click="toTip">举报</span>
    </van-col>
  </van-row>
</div>
<div class="comments" id="target" v-if="info.replyshow==0">
  <h2><span class="borderleft"></span>全部评论</h2>
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="已加载全部"
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="img.loading" />
  </div>
  <div class="comment">
    <van-row class="btn-bor" gutter="15" v-for="(comment, index) in comments" :key="'commment_' + comment.id">
     <van-col span="3" @click="goMy(comment.user.id,comment.user.form)">
      <div class="infohand_box">
       <img class="avatar" :src="comment.user && comment.user.headimg_url&&comment.user.headimg_url.substring(0,5)=='https' ? comment.user.headimg_url : img.avatar" />
       <img class="infohand_border" :src="img.border_pic" v-if="comment.user.auth.is_audit==1">
     </div>
   </van-col>
   <van-col span="21">
     <div class="user_info">
      <div class="van-ellipsis">{{ comment.user.user_name }}<span class="f-12 c-gray" style="font-weight: 400;" v-if="comment.user.form">[{{comment.user.form}}</span>
        <div class="mycars" v-if="comment.user.cars.id"><img class="member_car" :src="img.member_car">{{comment.user.cars.title}} 车主</div>
      </div>
      <div class="binbox">
        <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.collect_have : img.collect">
        <span class="sourtime">{{ comment.praise_num }}</span>
      </div>
    </div>
    <p v-if="comment.content">{{ comment.content }}</p>
    <p class="time">{{ comment.create_time }}
      <span class="c-black" @click="replys(comment.id)"> · 回复
        <span v-if="comment.replys">({{ comment.replys.length }})</span>
      </span>
      <span v-if="comment.user.id==params.user_id" class="f-r" @click="delComment(comment.id,index)">删除</span>
      <span v-else class="f-r f-12" @click="toTip">举报</span>
    </p>
    <div class="replys" v-if="comment.replys">
      <router-link class="f-12 c-blue" :to="{name: 'LexusContentShowComment', params: {id: comment.id,postid:post_id}}">
        <van-row v-for="(reply,index) in comment.replys" :key="'replys_' + reply.id" v-show="index>2?false:true">
          <van-col span="3">
            <div class="headimg_box">
              <img class="headimg" :src="reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" >
              <img class="headimg_border" :src="img.border_pic" v-if="reply.user.auth.is_audit==1">
            </div>
          </van-col>
          <van-col span="21">
            <span class="f-w" v-if="reply.user">{{ reply.user.user_name }}</span>
            <span class="pd-5" v-if="reply.reuser">回复</span>
            <span class="f-w">{{ reply.reuser.user_name }} :</span>
            {{ reply.content }}
          </van-col>
        </van-row>
      </router-link>
    </div>
  </van-col>
</van-row>
</div>
</van-list>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8" @click="goBotcom()"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="info.reply_num>0">{{info.reply_num}}</span>
          </span>
        </van-col>
        <van-col span="10">
          <span class="binbox" @click="Collect(info.is_collect)">
            <img class="binpic" :src="info.is_collect==1?img.collect_have:img.collect">
            <span class="num" v-if="info.collect>0">{{info.collect}}</span>
          </span>
        </van-col>
        <van-col span="6">
          <span class="binbox" @click="outrelay(info.title,info.subtitle,id,info.share_image)">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
  <van-popup v-model="showpop" class="userpop">
    <div class="sourcepop">来自{{sourceName}}的评论</div>
    <div @click="closePop">取消</div>
  </van-popup>
</div>
</template>
<script>
  import content from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import {Row, Col, Tag,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Popup} from "vant";
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
       value:'',
       inputshow:true,
       post_id: 0,
       overlay:false,
       inputfocus:false,
       inputnum:14,
       rid:'',
       info: '' ,
       recommends: [],
       tripartite_info:[],
       params: {
        page: 1,
        size: 4,
        order: 1,
        user_id: 0
      },
      loading: false,
      finished: false,
      comments: [],
      shareshow:false,
      showpop: false,
      sourceName:'',
      content:'',
      img: {
        avatar: require('../../../assets/img/lexus/default.png'),
        show_parise: require('../../../assets/img/show_parise.png'),
        parise_have: require('../../../assets/img/parise_have.png'),
        show_no_parise: require('../../../assets/img/show_no_parise.png'),
        no_parise_have: require('../../../assets/img/no_parise_have.png'),
        collect: require('../../../assets/img/lexus/collect.png'),
        collect_have: require('../../../assets/img/lexus/collect_have.png'),
        comment: require('../../../assets/img/lexus/comment.png'),
        inrelay: require('../../../assets/img/lexus/inrelay.png'),
        outrelay: require('../../../assets/img/lexus/outrelay.png'),
        friends: require('../../../assets/img/lexus/friends.png'),
        wechat: require('../../../assets/img/lexus/wechat.png'),
        link: require('../../../assets/img/lexus/link.png'),
        poster: require('../../../assets/img/lexus/poster.png'),
        member_car: require('../../../assets/img/member_car.png'),
        border_pic:require('../../../assets/img/lexus/border.gif'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  watch: {
    '$route'() {
      if(this.$route.params.id != this.post_id) {
        this.post_id = this.$route.params.id
        this.getInfo()
        this.getRecommends()
      }
    }
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    let id = this.$route.params.id
    this.weburl=process.env.VUE_APP_URL
    if(this.$util.isEmpty(id)) {
      this.$toast('内容不存在')
      return false
    }
    this.post_id = id
    this.getInfo()
    this.getRecommends()
  },
  activated () {
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      }
    })
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
  },
  methods: {
    setPraise () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.is_praise ? 2 : 1;
        content.setPraise({id: this.info.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.is_praise = 1
              this.info.praise += 1

              //取消一般般
              if(this.info.is_praise_no) {
                content.setNoPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise_no = 0
                })
              }
            } else {
              this.info.is_praise = 0
              this.info.praise -= 1
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    setNoPraise () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.is_praise_no ? 2 : 1;
        content.setNoPraise({id: this.info.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.is_praise_no = 1
              //取消点赞
              if(this.info.is_praise) {
                content.setPraise({id: this.info.id, type: 2}).then(res => {
                  this.info.is_praise = 0
                  this.info.praise -= 1
                })
              }
            } else {
              this.info.is_praise_no = 0
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    getInfo () {
      content.getShow(this.post_id).then(res => {
        if(res.data.state == 1) {
          this.info = res.data.data
          var str=this.info.content.replace(/(<br\s?\/?>)+/g, '')
          let regex = /<p>[\s\n\t&nbsp;]*<\/p>/g;
          this.content= str.replace(regex, "<p></p>");  
          this.tripartite_info=res.data.data.tripartite_info
          this.$util.title(res.data.data.title)
          var apppar={
            title:res.data.data.title
          }
          this.$appService.changeTitle(apppar)
          if(res.data.data.title){
            document.title = res.data.data.title;
          }
          document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.keywords)
          document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.description)
          var params={
            event_code: '文章视频详情',
            event_id: this.info.id,
            title: this.info.title,
            value: '',
            path: '/Lexus/Content/LexusVideoShow.vue',
            user_id: this.user ? this.user.id : 0,
            source: this.source
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){
            }
          })
        }
      })
    },
    toTip() {
      this.$toast.success('举报成功')
    },
    getRecommends () {
      content.getRecommends(this.post_id, {}).then(res => {
        if(res.data.state == 1) {
          this.recommends = res.data.data
        }
      })
    },
    setCommentPraise(index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.comments[index].is_praise ? 2 : 1;
        content.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.comments[index].is_praise = 1
              this.comments[index].praise_num += 1
            } else {
              this.comments[index].is_praise = 0
              this.comments[index].praise_num -= 1
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
      inputFocus(){//点击输入框聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
                var binding_status=res.data.data.phone_binding_status.status
                var mobile=res.data.data.mobile
                if(mobile){
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  setTimeout(() => {
                    var cc=document.getElementById('inputid');
                    cc.scrollIntoViewIfNeeded(true);
                  },500)
                }else{
                  this.$refs.inputTag.blur()
                  this.$dialog.confirm({
                   title:'温馨提示',
                   message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                   width:'80%',
                   messageAlign:'left',
                   confirmButtonText:'去绑定',
                 }).then(() => {
                   var params={
                    url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                    isReturn: true 
                  }
                  this.$appService.openWebView(params)

                }).catch(() => {
                 this.inputshow=false;
                 this.overlay=true;
                 this.inputnum=19;
                 setTimeout(() => {
                  var cc=document.getElementById('inputid');
                  cc.scrollIntoViewIfNeeded(true);
                },500)
               });

              }
            }
          })
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })

      },
      replys(rid){//点击回复聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
                var binding_status=res.data.data.phone_binding_status.status
                var mobile=res.data.data.mobile
                if(mobile){
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  this.inputfocus=true
                  this.$refs.inputTag.focus()
                  this.rid=rid
                  setTimeout(() => {
                    var cc=document.getElementById('inputid');
                    cc.scrollIntoViewIfNeeded(true);
                  },500)
                }else{
                  this.$refs.inputTag.blur()
                  this.$dialog.confirm({
                    title:'温馨提示',
                    message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                    width:'80%',
                    messageAlign:'left',
                    confirmButtonText:'去绑定',
                  }).then(() => {
                   var params={
                    url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                    isReturn: true 
                  }
                  this.$appService.openWebView(params)
                }).catch(() => {
                 this.inputshow=false;
                 this.overlay=true;
                 this.inputnum=19;
                 this.inputfocus=true
                 this.$refs.inputTag.focus()
                 this.rid=rid
                 setTimeout(() => {
                  var cc=document.getElementById('inputid');
                  cc.scrollIntoViewIfNeeded(true);
                },500)
               });

              }
            }
          })
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
      },
      post(){
        let params={
          rid:this.rid,
          archive_id:this.post_id,
          content:this.value
        }
        content.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
        }
      })
      },
      getCommentList(){
        this.params.user_id = this.user ? this.user.id : 0
        this.params.source = this.source
        content.getCommentList(this.post_id, this.params).then(res => {
          var newlist = res.data.data.data
          for (var i = 0; i < newlist.length; i++) {
            if (newlist[i].user) {
              var user_name = newlist[i].user.user_name
              var arr = user_name.split('[');
              newlist[i].user.user_name = arr[0]
              newlist[i].user.form = arr[1]
              var replys = newlist[i].replys
              if (replys) {
                for (var j = 0; j < replys.length; j++) {
                  var user_name = replys[j].user.user_name
                  var arr = user_name.split('[');
                  replys[j].user.user_name = arr[0]
                  replys[j].user.form = arr[1]
                  var ruser_name = replys[j].reuser.user_name
                  var rarr = ruser_name.split('[');
                  replys[j].reuser.user_name = rarr[0]
                  replys[j].reuser.form = rarr[1]
                }
              }
            }
          }
          this.comments.push.apply(this.comments, newlist)
          this.params.page += 1
          this.loading = false
          if(res.data.data.length == 0) {
            this.finished = true
          }
        })
      },
     goBotcom(){//页面滚动到底部评论
      document.getElementById("target").scrollIntoView();
    },
    delComment(id,index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
       content.delComment(id).then(res => {
        if(res.data.state == 1) {
          this.$toast.success('已删除')
          this.comments.splice(index,1);
        }
      })
     }).catch(() => {});
    },
    onCancel(){
      this.actionshow=false
    },
    outrelay(title,content,id,imageUrl){
      var user_id=this.user?this.user.id:0
      this.shareshow=true
      this.sharetitle=title
      this.sharecontent=content
      this.shareurl='/pages/article/article?scene='+id+'-'+user_id
      this.shareweburl=this.weburl+'/lexus/article/'+id+'/video'+'?source='+this.source
      if(imageUrl){
        this.shareimageUrl=imageUrl
      }else{
        this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
      }

    },
    toShare(type){
      if(type==1){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl,
          weburl:this.shareweburl,
          wechatid:'gh_d2c493f1bc41'
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      }else{
        this.$appService.getToken(v => {
          if(v.token) {
            var para={
              source:9,
              id:this.post_id,
              user_id:this.user.id
            }
            content.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.shareContent(params)
              }
            })
          }else{
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
      }
    },
    goMy(id,from){
      if(from){
        var sourceName = from.substr(0, from.length - 1)
        this.sourceName=sourceName
        this.showpop=true
      }else{
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    closePop(){
      this.showpop=false
    },
    onLoad() {
      setTimeout(() => {
        this.getCommentList()
      }, 500);
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tag.name]: Tag,
    [List.name]:List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [ActionSheet.name]:ActionSheet,
    [Divider.name]:Divider,
    [Popup.name]:Popup
  }
};
</script>

<style lang="scss">
  .content-post-show {
    margin-bottom: 50px;
    background-color: #F0F0F0;
    .img{
      width: 100%;
      height: 250px;
      display: block;
      object-fit: cover;
    }
    .posttitle{
      vertical-align: middle;
    }
    .mr-10{
      margin-right: 10px;
    }
    .show {
      padding: 10px;
      background-color: #FFF;
      font-size: 14px;
      color: #3A3A3A;
      h3 {
        font-size: 16px;
        margin: 0;
      }
      .mt-40{
        margin-top: 40px;
      }
      .media {
        color: #9A9A9A;
        font-size: 12px;
        margin: 20px 0;
        img {
          width: 30px;
          border-radius: 15px;
          vertical-align: middle;
        }
      }
      .content {
        font-size: 14px !important;
        margin-top: 0px;
        img {
          max-width: 100%;
          line-height: 0 !important;
        }
        p{
          span{
            line-height: 1.8 !important;
          }
        }
        iframe{
          max-width: 100%;
        }
        video{
          max-width: 100%;
        }
      }
      .content iframe{
        width: 100%;
        height: 200px;
      }
      .content video{
        width: 100%;
        height: 200px;
      }
      .parise {
        text-align: center;
        margin: 30px 0 50px 0;

        a {
          color: #3A3A3A;
          font-size: 12px;
          display: inline-block;
          width: 110px;
          height: 35px;
          line-height: 35px;
          border-radius: 2px;
          margin: 0 7px;
          box-sizing: border-box;
          background-color: #F3F9FF;
          border: none;
          img {
            width: 15px;
            height: 14px;
            vertical-align: middle;
            margin-right: 7px;
          }
        }
      }
    }
    .recommend {
      padding: 10px;
      border-top: 1px solid #EAEAEA;
      background-color: #fff;
      margin-top: 10px;
      h3 {
        font-size: 13px;
      }
      img {
        width: 100%;
        height: 100px;
        // border-radius: 3px;
        display: block;
        object-fit: cover;
      }
      h2 {
        font-size: 15px;
        margin: 0;
        color: #3A3A3A;
        font-weight: 400;
        .van-tag {
          font-weight: normal;
        }
      }
      .van-row {
        margin-bottom: 10px;
      }

      .picthere{
        width: 100%;
        height: auto;
      }
      .van-grid-item__content{
        padding: 10px 0;
      }
    }
    .borderleft{
      margin-right: 10px;
      border-left: 3px solid #3A3A3A;
    }
    .comments {
      background-color: #FFF;
      margin-top: 10px;

      h2 {
        font-size: 14px;
        font-weight: bold;
        padding: 15px 10px;
        border-bottom: 1px solid #f8f8f8;
        margin: 0;
      }
      .comment {
        // margin: 0 10px;
        overflow: hidden;
        .van-row {
          padding: 5px 0;
        }
        .btn-bor{
          padding: 10px;
          border-bottom: 1px solid #f8f8f8;
        }
        .avatar {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 1.5px;
        }
        .infohand_box{
          width:40px;
          height:45px;
          position: relative;
        }
        .infohand_border{
         width:40px;
         height:40px;
         position: absolute;
         left: 0;
       }
       .user_info {
        font-size: 15px;
        font-weight: bold;
        color: #605c6b;
        display: flex;
        align-items: center;
        height: 40px;
        .van-ellipsis{
          flex: 1;
          display: inline-block;
        }
        .mycars{
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #9A9A9A;
          vertical-align: middle
        }
        .binbox {
          color: #9A9A9A;
          font-size: 12px;
          float: right;
          font-weight: normal;

          img {
            width: 15px;
            height: 14px;
            margin-right: 11px;
            vertical-align: middle;
          }
          .sourtime{
            vertical-align: middle;
          }
        }
      }
      p {
        font-size: 13px;

        .c-blue {
          font-style: normal;
        }
        &.time {
          font-size: 12px;
          color: #9A9A9A;

          span {
            margin-left: 5px;
          }
        }
      }
      .headimg  {
        width: 25px;
        border-radius: 1.5px;
      }
      .headimg_box{
        width:25px;
        height:25px;
        position: relative;
      }
      .headimg_border{
       width:25px;
       height:25px;
       position: absolute;
       left: 0;
     }
     .replys {
      .van-row {
        font-size: 13px;
      }
      .pd-5{
        padding: 0 5px;
      }

    }
  }
}
a{
  color: #3A3A3A;
}
iframe{
  width: 100%;
  height: 210px;
}
.van-popup{
  .van-action-sheet__cancel::before{
    height: 1px;
  }
  .divider{
    margin: 20px 80px;
  }
}
}
</style>
